import { MapPin } from 'lucide-react';

export default function MapFallback({ loading = false, message } = {}) {
    const label = loading
        ? 'Loading map...'
        : message || 'Map unavailable';

    return (
        <div className="relative flex h-full min-h-[220px] w-full items-center justify-center overflow-hidden bg-[url('/assets/images/map-view.webp')] bg-cover bg-center">
            <div className="absolute inset-0 bg-white/75" />
            <div className="relative flex max-w-[18rem] flex-col items-center px-5 text-center">
                <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-[#ffea00] text-black shadow-sm">
                    <MapPin size={24} strokeWidth={2.5} />
                </div>
                <p className="mb-0 text-sm font-bold text-gray-900">{label}</p>
                {!loading && (
                    <p className="mb-0 mt-1 text-xs font-medium leading-5 text-gray-600">
                        Check the production Google Maps browser key and rebuild the frontend assets.
                    </p>
                )}
            </div>
        </div>
    );
}
